import { render } from "./HomeGameComponent.vue?vue&type=template&id=54dbb706"
import script from "./HomeGameComponent.vue?vue&type=script&lang=js"
export * from "./HomeGameComponent.vue?vue&type=script&lang=js"

import "./HomeGameComponent.vue?vue&type=style&index=0&id=54dbb706&lang=scss"

import exportComponent from "/home/runner/work/schFront/schFront/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__